var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"grow"}},[(_vm.$store.getters['auth/isRefreshing'])?_c('div',{staticClass:"progress-bar"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }